import React, { useEffect, useState } from "react";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";
import { UserService } from "../../../app/service/user.service";
import { useNavigate } from "react-router-dom";

const DisplayQuestions = () => {
  const [page, setPage] = useState(0);
  const [data, setData] = useState<any[]>([]);
  const [answers, setAnswers] = useState<{ [key: string]: number }>({});
  const navigate=useNavigate()

  const questionsPerPage = 4;
  const totalPages = Math.ceil(data.length / questionsPerPage);
  const startIndex = page * questionsPerPage;
  const currentQuestions = data.slice(startIndex, startIndex + questionsPerPage);

  const handleNext = () => page < totalPages - 1 && setPage(page + 1);
  const handlePrevious = () => page > 0 && setPage(page - 1);

  useEffect(() => {
    const email = sessionStorage.getItem("guestEmail");
  
    if (!email) {
      navigate("/", { replace: true }); // Redirect to homepage
      return;
    }
  
    getRegisters();
  }, []);

  const getRegisters = () => {
    const collegeId = sessionStorage.getItem("collegeId");
     AdminService.allQuestions(collegeId).then((res: any) => {
          if (res.status === "Success") {
            setData(res.data);
          }
          else{
            toast.error(res.message);
          }
        });
  };

  const handleSelectAnswer = (questionId: string, optionIndex: number) => {
    setAnswers((prev) => ({ ...prev, [questionId]: optionIndex }));
  };

  const handleSubmit = () => {
    // Calculate score
    let score = 0;
    data.forEach((q: any) => {
      if (answers[q._id] === q.correctAnswer) score++;
    });
  
    // Format answers for API
    const formattedAnswers = Object.keys(answers).map((qId) => ({
      questionId: qId,
      answer: answers[qId],
    }));
  
    const userEmail = sessionStorage.getItem("guestEmail");
  
    const payload = {
      emailAddress: userEmail,
      answers: formattedAnswers,
      score,            // ⬅️ Required
    };
  
    UserService.submitGuestExam(payload).then((res: any) => {
      if (res.status === "Failed") {
        toast.error(res.message);
      } else {
        toast.success("Exam Submitted Successfully!");
        sessionStorage.clear();
        navigate("/thank-you", {
          state: res.data,
        });
      }
    });
  };
  
  

  return (
    <div style={{ padding: "15px", maxWidth: "700px", margin: "0 auto" }}>
      {currentQuestions.map((q: any, index: number) => (
        <div
          key={q._id}
          style={{
            border: "1px solid #ddd",
            padding: "12px",
            marginBottom: "12px",
            borderRadius: "6px",
            background: "#fafafa",
            fontSize: "15px",
          }}
        >
          <h4 style={{ fontSize: "17px", marginBottom: "6px" }}>
            Q{startIndex + index + 1}. {q.question}
          </h4>

          {q.options.map((opt: string, idx: number) => (
            <label
              key={idx}
              style={{
                display: "block",
                padding: "3px 0",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              <input
                type="radio"
                name={q._id}
                value={idx}
                checked={answers[q._id] === idx}
                onChange={() => handleSelectAnswer(q._id, idx)}
                style={{ marginRight: "6px" }}
              />
              {opt}
            </label>
          ))}
        </div>
      ))}

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button disabled={page === 0} onClick={handlePrevious}>
          Previous
        </button>

        {page < totalPages - 1 ? (
          <button onClick={handleNext}>Next</button>
        ) : (
          <button
            onClick={handleSubmit}
            style={{
              background: "green",
              color: "white",
              padding: "6px 14px",
              borderRadius: "4px",
            }}
          >
            Submit
          </button>
        )}
      </div>

      <p style={{ textAlign: "center", marginTop: "10px" }}>
        Page {page + 1} of {totalPages}
      </p>
    </div>
  );
};

export default DisplayQuestions;
